import AgencyHelper from 'features/Agency/agencyHelper';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import ImageView from 'general/components/quybka/Images/ImageView';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogUploadInvoiceDocumentView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogUploadInvoiceDocumentView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [invoiceDocument, setInvoiceDocument] = useState('');

    useEffect(() => {
        if (item?.attachedFiles?.length) {
            setInvoiceDocument(item?.attachedFiles);
        } else {
            setInvoiceDocument('');
        }
    }, [item]);

    // MARK: ---- FUNCTIONS ----

    const handleSubmit = async () => {
        if (!invoiceDocument) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append('reconciliationId', item?.reconciliationId);
        formData.append('files', invoiceDocument);

        const result = await AgencyHelper.API.requestUploadInvoiceDocument(formData);

        if (result && _.isBoolean(result)) {
            ToastHelper.showSuccess('Tải lên hóa đơn thuế thành công');
            onDone?.();
        } else {
            ToastHelper.showError(result || 'Tải lên hóa đơn thuế thất bại');
        }

        setLoading(false);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* invoiceDocument */}
                <div className="col-6 px-2 mb-2">
                    <div>
                        {UIHelper.buildFormLabel('Hóa đơn thuế', true)}
                        <label className="">
                            {UIHelper.buildNegativeButton(
                                'Thêm tập tin',
                                () => { },
                                <i className="fa-regular fa-upload" />
                            )}
                            <input
                                type="file"
                                accept={['.pdf']}
                                onChange={(e) => {
                                    const files = e.target.files;
                                    if (!files || files.length === 0) return;
                                    const file = files[0];
                                    if (file.name.length > 128) {
                                        ToastHelper.showError("Tên file quá dài! Tối đa cho phép 128 ký tự.");
                                        e.target.value = null;
                                        return;
                                    }
                                    setInvoiceDocument(file);
                                }}
                                hidden
                                onClick={(e) => {
                                    e.target.value = null;
                                }}
                            />
                        </label>
                        {invoiceDocument && (
                            <div>
                                <ImageView
                                    name={invoiceDocument?.name ?? invoiceDocument?.split('/').pop()}
                                    fileName={invoiceDocument?.name ?? invoiceDocument?.split('/').pop()}
                                    path={
                                        _.isString(invoiceDocument)
                                            ? invoiceDocument
                                            : invoiceDocument?.name
                                    }
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    'Xác nhận',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogUploadInvoiceDocumentView;
